import DelegationModule from './delegation-module';
export default DelegationModule;
